import React from "react";
import { Card, Grid } from "@mui/material";
import Title from "./../ReusableComponents/title";
import HourProfitLossChart from "../Charts/HourProfitLossChart";
import HourResultTable from "./HourResultTable";
import CommonTable from "./CommonTable";
import { dollarUS } from "../../utilities/formatters";

const ResultsByOpenHour = ({ data }) => {
  // const dummyDta = [
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  //   {
  //     close: 765,
  //     no_of_trades: 2,
  //     open: 987,
  //   },
  // ];

  const columns = React.useMemo(
    () => [
      {
        Header: "Duration",
        accessor: "Duration",
      },
      {
        Header: "No of Trades",
        accessor: "no_of_trade",
      },
      {
        Header: "Results",
        accessor: "results",
        Cell: ({ value }) => (
          <>
            <p
              className={`${
                value > 0 ? "profit_val" : value < 0 ? "loss_val" : ""
              }`}
            >
              {dollarUS(value)}
            </p>
          </>
        ),
      },
    ],
    []
  );

  return (
    <Grid className="ResultByClose">
      {/* <Grid
        className="longshort-inner"
        item
        xs={12}
        md={6}
        sx={{ paddingLeft: { xs: 0 } }}
      > */}
      <Title six>Results by Open Hour</Title>
      <Card className="card-csc">
        <CommonTable data={data} columns={columns} />
      </Card>
      {/* </Grid> */}
    </Grid>
  );
};

export default ResultsByOpenHour;
